import * as Yup from 'yup'
/* eslint-disable import/prefer-default-export */
export const schema = Yup.object().shape({
  affair: Yup.string().required('El asunto es requerido'),
  message: Yup.string().required('El mensaje es requerido'),
  toCreate: Yup.boolean(),
  type: Yup.string().required('El tipo es requerido'),
  programKey: Yup.string().required('El programa es requerido')
})
